import { render, staticRenderFns } from "./UnitConfig.vue?vue&type=template&id=2907c6c8&scoped=true&"
import script from "./UnitConfig.vue?vue&type=script&lang=js&"
export * from "./UnitConfig.vue?vue&type=script&lang=js&"
import style0 from "./UnitConfig.vue?vue&type=style&index=0&id=2907c6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907c6c8",
  null
  
)

export default component.exports